import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Card, Form, Button, Container, Row, Col } from 'react-bootstrap';
import * as Common from './Common';
import Dialog from './Dialog';
import Loginheader from './Loginheader';

let loginBox = {
    width: '650px',
    maxWidth: '100%',
    marginTop: '50px'
}

function Login() {
    const navigate = useNavigate();
    const { state } = useLocation();

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const [isSignIn, setIsSignIn] = useState(true);
    const [isForget, setIsForget] = useState(false);
    const [userId, setUserId] = useState("");
    const [userPass, setUserPass] = useState("");
    const [userEmail, setEmail] = useState("");

    sessionStorage.clear();

    function onClickForget() {
        setIsSignIn(false);
        setIsForget(true);
    }

    function onClickGoBack() {
        setIsForget(false);
        setIsSignIn(true);
    }

    function onClickSignIn() {
        //// Not in use use loginv1.js
        sessionStorage.clear();
        if (userId === "" || userPass === "") {
            setMsgText(Common.getMessage("MSG0001"));
            setMsgBox(true);
        } else {
            Common.callApi(Common.apiLogin, ['validate', userId, userPass], function (result) {
                let resp = JSON.parse(result);
                if (resp.status === "MSG0000") {
                    sessionStorage.sessionId = resp.session;
                    sessionStorage.userName = resp.name;
                    sessionStorage.entityId = resp.entityid;
                    sessionStorage.entityType = resp.entitytype;
                    sessionStorage.myInterval = "";
                    sessionStorage.nocoverviewagent = resp.nocoverviewagent;
                    sessionStorage.disableCommissionChange = resp.disableCommissionChange;

                    console.log("In Validate");
                    if (resp.chg_pw_on_logon === "0" || resp.chg_pw_on_logon === 0) {
                        sessionStorage.chngPassOnLogin = 0;
                        navigate("/new-request");
                    } else if (resp.chg_pw_on_logon === "1" || resp.chg_pw_on_logon === 1) {
                        sessionStorage.chngPassOnLogin = 1;
                        navigate("/changepassword");
                    } else {
                        setMsgText(Common.getMessage("ERR0000"));
                        setMsgBox(true);
                    }
                } else {
                    setMsgText(Common.getMessage(resp.status));
                    setMsgBox(true);
                }
            });
        }
    }

    function onClickReset() {
        console.log("In Reset");
        console.log('This is the value', userId, userEmail);
        if (userId === "" || userEmail === "") {
            setMsgText("Invalid User Id or Email Id.");
            setMsgBox(true);
        } else {
            Common.callApi(Common.apiLogin, ['reset', userId, userEmail], function (result) {
                let resp = JSON.parse(result);
                setMsgText(resp.msg);
                setMsgBox(true);
                onClickGoBack();
            });
        }
    }

    return (
        <>
            <div >
                <Loginheader></Loginheader>
                <Container>
                    <Row>
                        <Col>
                            <div className="divContentCenter">
                                <div style={loginBox} className="Shadow">
                                    <Card>
                                        <Card.Header><h6>{isSignIn ? "Sign In" : null}{isForget ? "Reset Password" : null}</h6></Card.Header>
                                        <Card.Body>
                                            <Form>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>User Id </Form.Label>
                                                    <Form.Control type="text" maxLength="20" onChange={(e) => setUserId(e.target.value.trim())} autoComplete="off" ></Form.Control>
                                                </Form.Group>
                                                {
                                                    isSignIn ?
                                                        <>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Password</Form.Label>
                                                                <Form.Control type="Password" maxLength="20" onChange={(e) => setUserPass(e.target.value.trim())} autoComplete="off"></Form.Control>
                                                            </Form.Group>
                                                            <Form.Group >
                                                                <Button variant="outline-primary" size="sm" onClick={() => onClickSignIn()}>Sign In</Button>
                                                            </Form.Group>
                                                        </>
                                                        : null
                                                }
                                                {
                                                    isForget ?
                                                        <>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Email Id</Form.Label>
                                                                <Form.Control type="text" onChange={(e) => setEmail(e.target.value.trim())} autoComplete="off"></Form.Control>
                                                            </Form.Group>
                                                            <Form.Group >
                                                                <Button variant="outline-primary" size="sm" onClick={() => onClickReset()}>Reset</Button>{' '}
                                                                <Button variant="outline-primary" size="sm" onClick={() => onClickGoBack()}>Back</Button>
                                                            </Form.Group>
                                                        </>
                                                        : null
                                                }
                                            </Form>
                                        </Card.Body>
                                        <Card.Footer>
                                            {
                                                isSignIn ?
                                                    <h6 ><span onClick={onClickForget} className="handCursor">Forget Password ?</span></h6>
                                                    : null
                                            }
                                        </Card.Footer>
                                    </Card>
                                </div>
                            </div>

                        </Col>
                    </Row>
                </Container>

                <div>
                    <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                        {msgText}
                    </Dialog>
                </div>
            </div>

        </>
    );
}
export default Login;